import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/zh-cn/industries/pharma-biotech/")({
  head: () => buildRouteHead("/zh-cn/industries/pharma-biotech"),
  component: IndustryPage,
});

